import * as React from 'react';
import ReactTable from 'react-table';
import { default as Renderers } from '../../sys/columns';
import DatePicker from 'react-datepicker';
import { Input, Dropdown, Button, Modal, Tab } from 'semantic-ui-react';
import OAuth, { DataRequest, OAuthClientStatus, TimeRange, RefreshFunctionSignature } from '../../api';
import CustomPagination from '../../sys/pagination';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-table/react-table.css';
import RequestParameters from '../../api/parameters';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import * as moment from 'moment';
const _ = require('lodash');
const fileDownload = require('js-file-download');

class State {
    data: any;
    groupby: Array<string>;
    startDate: any;
    endDate: any;
    assetFilter: any;
    streamFilter: any;
    spliceFilter: any;
    spliceTypeFilter: any;
    segTypeFilter: any;
    scteTabSelected: boolean;
    refresh ?: number;
    openModal ?: boolean;
    modalText: string;
    id3:any;
}

interface Props {
}

export default class DAILogView extends React.Component<Props, State> {

    private dataRefresh: RefreshFunctionSignature;

    componentWillMount() {
        this.setState({
            refresh: 10000,
            data: [],
            groupby: [],
            startDate: '',
            endDate: '',
            assetFilter: '',
            streamFilter: '',
            spliceFilter: '',
            spliceTypeFilter: '',
            segTypeFilter: '',
            scteTabSelected: true,
            openModal: false,
            modalText: '',
        });
        this.setRefreshInterval = this.setRefreshInterval.bind(this);
        this.clearLog = this.clearLog.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
    }

    setRefreshInterval(interval?: number) {
        this.setState({ refresh: interval });
    }

    handleFilter() {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);
    }
    handleReset() {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);

        this.setState({
                startDate: '',
                endDate: '',
                assetFilter: '',
                streamFilter: '',
                spliceFilter: '',
                spliceTypeFilter: '',
                segTypeFilter: ''
            });
    }

    render() {
        const {
            // view state
            scteTabSelected, groupby,
            // filters
            startDate, endDate, assetFilter, streamFilter, spliceFilter, spliceTypeFilter, segTypeFilter
        } = this.state;

        const inlineStyle = {
            modal : {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        const spliceTypeOptions = [{value: '', text: 'All'},
            {value: 1, text: 'Out'},
            {value: 2, text: 'In'},
            {value: 3, text: 'ID3'}];
        
        const segmentationTypes = [
        	{text: 'All', value: ''},           
            {text : '0x10(16): Program Start', value : 16},
            {text : '0x11(17): Program End', value : 17},
            {text : '0x12(18): Program Early Termination', value : 18}, 
            {text : '0x13(19): Program Breakaway', value : 19},
            {text : '0x14(20): Program Resumption', value : 20},
            {text : '0x15(21): Program Runover Planned', value : 21},
            {text : '0x16(22): Program Runover Unplanned', value : 22},
            {text : '0x17(23): Program Overlap Start', value : 23},
            {text : '0x18(24): Program Blackout Override', value : 24},
            {text : '0x19(25): Program Start In Progress', value : 25},
            {text : '0x20(32): Chapter Start', value : 32},
            {text : '0x21(33): Chapter End', value : 32},
            {text : '0x22(34): Break Start', value : 34},
            {text : '0x23(35): Break End', value : 35},
            {text : '0x24(36): Opening Credit Start', value : 36},
            {text : '0x25(37): Opening Credit End', value : 37},
            {text : '0X26(38): Closing Credit Start', value : 38},
            {text : '0X27(39): Closing Credit End', value : 39},
            {text : '0x30(48): Provider Advertisement Start', value : 48},
            {text : '0x31(49): Provider Advertisement End', value : 49},
            {text : '0x32(50): Distributor Advertisement Start', value : 50},
            {text : '0x33(51): Distributor Advertisement End', value : 51},
            {text : '0x34(52): Provider Placement Opportunity Start', value : 52},
            {text : '0x35(53): Provider Placement Opportunity End', value : 53},
            {text : '0x36(54): Distributor Placement Opportunity Start', value : 54},
            {text : '0x37(55): Distributor Placement Opportunity End', value : 55},
            {text : '0x38(56): Provider Overlay Placement Opportunity Start', value : 56},
            {text : '0x39(57): Provider Overlay Placement Opportunity End', value : 57},
            {text : '0x3a(58): Distributor Overlay Placement Opportunity Start', value : 58},
            {text : '0x3b(59): Distributor Overlay Placement Opportunity End', value : 59},
            {text : '0x3c(60): Provider Promo Start', value : 60},
            {text : '0x3d(61): Provider Promo End', value : 61},
            {text : '0x3e(62): Distributor Promo Start', value : 62},
            {text : '0x3f(63): Distributor Promo End', value : 63},
            {text : '0x40(64): Unscheduled Event Start', value : 64},
            {text : '0x41(65): Unscheduled Event End', value : 65},
            {text : '0x44(68): Provider Ad Block Start', value : 68},
            {text : '0x45(69): Provider Ad Block End', value : 69},
            {text : '0x46(70): Distributor Ad Block Start', value : 70},
            {text : '0x47(71): Distributor Ad Block End', value : 71},
            {text : '0x50(80): Network Start', value : 80},
            {text : '0x51(81): Network End', value : 81}
        ];

        const panes = [
            { menuItem: 'SCTE-35'}, { menuItem: 'ID3'}
        ];

        const columns = [{
            width: 15
        }, {
            Header: 'Stream Information',
            columns: [
                {
                    Header: 'Time Detected',
                    accessor: 'timestamp',
                    width: 180,
                    headerStyle: { textAlign: 'left' },
                    aggregate: (values: any, row: any) => (values.length > 0) ? { min: _.min(values), max: _.max(values) } : null,
                    Cell: (props: any) => Renderers.timestamp.format(props.value),
                    Aggregated: (row: any) => (
                        <span className="aggregated-timestamp">
                        {Renderers.timestamp.format(row.value.min)} to {Renderers.timestamp.format(row.value.max)}
                        </span>
                    )
                }, {
                    Header: 'Asset Name',
                    accessor: 'assetName',
                    width: 220,
                    headerStyle: { textAlign: 'left' }
                }, {
                    Header: 'Stream Name',
                    accessor: 'name',
                    headerStyle: { textAlign: 'left' },
                    width: 300,
                    // Cell: (props: any) => this.streamNameRenderer(props),
                    Aggregated: (row: any) => { return null; }
                },
            ]
        }, {
            Header: 'ABR Presentation',
            columns: [
                {
                    Header: 'Splice Time',
                    accessor: 'ABRPresentation.spliceStart',
                    Cell: (props: any) => Renderers.timestamp.format(props.value),
                    headerStyle: { textAlign: 'left' },
                    width: 180
                }, {
                    Header: 'Splice Type',
                    accessor: 'ABRPresentation.spliceType',
                    headerStyle: { textAlign: 'left' },
                    Cell: (props: any) => this.spliceTypeRenderer(props.value),
                    width: 100
                }, {
                    Header: 'Splice Identifier',
                    accessor: 'ABRPresentation.spliceId',
                    width: 120,
                    align: 'right',
                    headerStyle: { textAlign: 'right' }
                }, {
                    Header: (h: any) => (<span>Splice Duration<br/>(sec)</span>),
                    accessor: 'ABRPresentation.spliceDur',
                    headerStyle: { textAlign: 'right' },
                    align: 'right',
                    Cell: (props: any) => this.spliceDurRenderer(props.value, false),
                    width: 120
                }, {
                    Header: (h: any) => (<span>Splice Duration<br/>Expected (sec)</span>),
                    accessor: 'ABRPresentation.spliceDurExp',
                    headerStyle: { textAlign: 'right' },
                    align: 'right',
                    Cell: (props: any) => this.spliceDurRenderer(props.value, true),
                    width: 120
                }
            ]
        }, ... this.state.scteTabSelected ? [{
            Header: 'SCTE 35' ,
            columns: [
                {
                    Header: 'Splice Time',
                    accessor: 'spliceInsert.spliceTime',
                    headerStyle: { textAlign: 'left' },
                    align: 'right',
                    show: () => scteTabSelected,
                    Cell: (props: any) => this.spliceDurRenderer(props.value, false),
                    width: 110
                },{
                    Header: 'Command Type',
                    headerStyle: { textAlign: 'left' },
                    accessor: 'cmdType',
                    align: 'left',
                    show: () => scteTabSelected,
                    Cell: (props: any) => this.spliceCommandTypeMap(props.value),
                    width: 120
                }, {
                    Header:'Segmentation Type Id',
                    accessor: 'spliceInsert.segmentationTypeId',
                    width: 300,
                    show: () => scteTabSelected,
                    align: 'left',
                    Cell: (props: any) => props.value,
                    headerStyle: { textAlign: 'left' }
                }, {
                    Header: (h: any) => (<span>Splice Event<br/>Identifier</span>),
                    accessor: 'spliceInsert.spliceEventId',
                    width: 100,
                    show: () => scteTabSelected,
                    align: 'right',
                    headerStyle: { textAlign: 'right' }
                }, {
                    Header: (h: any) => (<span>Cancel<br/>Indicator</span>),
                    accessor: 'spliceInsert.cancelIndicator',
                    width: 100,
                    show: () => scteTabSelected,
                    align: 'right',
                    Cell: (props: any) => this.booleanRenderer(props.value),
                    headerStyle: { textAlign: 'right' }
                }, {
                    Header: (h: any) => (<span>Out-Of-<br/>Network<br/>Indicator</span>),
                    accessor: 'spliceInsert.ooni',
                    show: () => scteTabSelected,
                    width: 100,
                    Cell: (props: any) => this.booleanRenderer(props.value),
                    align: 'right',
                    headerStyle: { textAlign: 'right' }
                }, {
                    Header: (h: any) => (<span>Unique Program<br/>Identifier</span>),
                    accessor: 'spliceInsert.uniqueProgId',
                    show: () => scteTabSelected,
                    width: 130,
                    align: 'right',
                    headerStyle: { textAlign: 'right' }
                }, {
                    Header: 'Avail Num',
                    accessor: 'spliceInsert.availNum',
                    show: () => scteTabSelected,
                    width: 100,
                    align: 'right',
                    headerStyle: { textAlign: 'right' }
                }, {
                    Header: 'Avails Expected',
                    accessor: 'spliceInsert.availExp',
                    show: () => scteTabSelected,
                    width: 140,
                    align: 'right',
                    headerStyle: { textAlign: 'right' }
                }, {
                    Header: 'Break Duration',
                    accessor: 'spliceInsert.breakDuration',
                    headerStyle: { textAlign: 'right' },
                    align: 'right',
                    show: () => scteTabSelected,
                    Cell: (props: any) => this.spliceDurRenderer(props.value, false),
                    width: 120
                }, {
                    Header: 'Auto Return',
                    accessor: 'spliceInsert.autoReturn',
                    headerStyle: { textAlign: 'right' },
                    align: 'right',
                    show: () => scteTabSelected,
                    Cell: (props: any) => this.booleanRenderer(props.value),
                    width: 120
                }, {
                    Header: (h: any) => (<span>Provider Avail<br/>Identifier</span>),
                    accessor: 'spliceInsert.providerAvailId',
                    headerStyle: { textAlign: 'right' },
                    align: 'right',
                    Cell: (props: any) => this.providerAvailIdRenderer(props.value),
                    show: () => scteTabSelected,
                    width: 140
                }
            ]
        }, ] : [],
            ... !scteTabSelected ? [{
                Header: 'ID3',
                columns: [
                    {
                        Header: 'ID3 PID',
                        accessor: 'ABRPresentation.id3Pid',
                        width: 100,
                        align: 'right',
                        headerStyle: { textAlign: 'right' }
                    }, {
                        Header: (h: any) => (<span>ID3 Media<br/>Sequence</span>),
                        accessor: 'ABRPresentation.id3MfSeq',
                        width: 100,
                        align: 'right',
                        headerStyle: { textAlign: 'right' }
                    }]
            }] : []];
        {Renderers.ReactTable(columns); }

        let params;
        if ((streamFilter.startsWith('\'') && streamFilter.endsWith('\'')) || (streamFilter.startsWith('\"') && streamFilter.endsWith('\"'))) {
            let tmpFilter = streamFilter.slice(1, streamFilter.length - 1);
            params = {
                // all the filters from state already pulled out into constants above (top of render function)
                timerange: new TimeRange({from: startDate, to: endDate}),
                assetName: assetFilter,
                exactName: tmpFilter,
                spliceId: spliceFilter,
                spliceType: spliceTypeFilter,
                segType: segTypeFilter
            };
        } else {
            params = {
                // all the filters from state already pulled out into constants above (top of render function)
                timerange: new TimeRange({from: startDate, to: endDate}),
                assetName: assetFilter,
                name: streamFilter,
                spliceId: spliceFilter,
                spliceType: spliceTypeFilter,
                segType: segTypeFilter
            };
        }

        return (
            <div className="view-content" id="alarmlog">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Dynamic Ad Insertion Log</div>
                        </div>
                    </div>
                </div>
                <OAuth.Context>{(oauth: OAuthClientStatus) => (
                    <div className="filterPanel">
                        <DatePicker
                            className="datePicker1SearchBox marginBotton8px"
                            todayButton={'Today'}
                            placeholderText={'Start Time'}
                            selected={startDate}
                            value={this.state.startDate ? moment(this.state.startDate).format('LLL') : undefined}
                            onChange={(date) => this.setState({startDate: date})}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="LLL"
                            isClearable={this.state.startDate ? true : false}
                        />
                        <DatePicker
                            className="datePicker2SearchBox marginBotton8px"
                            todayButton={'Today'}
                            placeholderText={'End Time'}
                            selected={endDate}
                            value={this.state.endDate ? moment(this.state.endDate).format('LLL') : undefined}
                            onChange={(date) => this.setState({endDate: date})}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="LLL"
                            isClearable={this.state.endDate ? true : false}
                        />
                        <Input
                            className="filterPanelSearchBox marginBotton8px"
                            placeholder="Asset Name"
                            value={assetFilter}
                            onChange={(event, data) => this.setState({assetFilter: data.value})}
                        />
                        <Input
                            className="filterPanelSearchBox"
                            placeholder="Stream Name"
                            value={streamFilter}
                            onChange={(event, data) => this.setState({streamFilter: data.value})}
                        />
                        <Input
                            className="filterPanelSearchBox marginBotton8px"
                            placeholder="Splice Identifier"
                            value={spliceFilter}
                            onChange={(event, data) => this.setState({spliceFilter: data.value})}
                        />
                        <Dropdown
                            className="alarmLogDropDown marginBotton8px"                   
                            placeholder="Splice Type"
                            value={spliceTypeFilter}
                            search
                            selection
                            options={spliceTypeOptions}
                            onChange={(event, data) => this.setState({spliceTypeFilter: data.value})}
                        />
                        <Dropdown
                            className="alarmLogDropDown marginLeft8px"
                            style={{width: `450px`}}
                            placeholder="Segmentation Type Id"
                            value={segTypeFilter}
                            search
                            selection
                            options={segmentationTypes}
                            onChange={(event, data) => this.setState({segTypeFilter: data.value})}
                        />
                        <div className="spacer"/>
                        {/*<Button className="filterPanel-primary-btn" content="Filter" onClick={() => this.handleFilter()}/>*/}
                        <Button className="filterPanel-secondary-btn" content="Reset" onClick={() => this.handleReset()}/>
                        <Button
                            className="filter-panel-rightButton"
                            icon="file excel outline"
                            content="Export"
                            onClick={(event, data) => this.exportLog(oauth)}
                        />

                        <OAuth.RequiresAdmin>
                            <Button
                                className="filterPanel-secondary-btn"
                                content="Clear log"
                                onClick={this.clearLog}
                            />
                        </OAuth.RequiresAdmin>
                    </div>
                )}</OAuth.Context>
                <Tab panes={panes} onTabChange={(event: any, data: any) => this.changeTab(data)}/>
                <div className="view-clientarea">
                    <DataRequest
                        auto                // automatically request on data change (filter change)
                        spinner             // show spinner when foreground loading (ex. on first load)
                        debounce={1500}     // debounce multiple requests (i.e. as user types in filter box)
                        interval={this.state.refresh}    // update every 10 seconds
                        method="get"
                        endpoint="http://default/api/log/dai"
                        params={params}
                    >{ (request: any) => {

                        this.dataRefresh = request.refresh;

                        // render a react table using the request data
                        return (
                            <ReactTable
                                className="transaction-log -striped -highlight outside-scroll"
                                pivotBy={groupby}
                                onFetchData={request.refresh}
                                data={this.formatData(request.data)}   
                                columns={columns}
                                defaultPageSize={16}
                                PaginationComponent={CustomPagination}
                                NoDataComponent={request.spinner ? () => null : undefined}
                                defaultSorted={[
                                    {
                                        id: 'timestamp',
                                        desc: true
                                    }
                                ]}
                            />
                        );
                    }}
                    </DataRequest>

                    <Modal
                        style={inlineStyle.modal}
                        open={this.state.openModal}
                        onClose={this.handleModalClose}
                        size="mini"
                    >
                        <Modal.Header>Clear Log</Modal.Header>
                        <Modal.Content>{this.state.modalText}</Modal.Content>
                        <Modal.Actions>
                            <Button onClick={this.handleModalClose}>OK</Button>
                        </Modal.Actions>
                    </Modal>
                </div>
            </div>
        );
    }

    streamNameRenderer(props: any) {
        return (props.original) ? props.original.assetName + '-' + props.original.extName : '';
    }

    formatData(data: any){
        let id3 = [];      
        if(data && data.dai){
			for (const each of data.dai) {
				if(each.mediaType == 'HLS'){
					id3.push(each);
				}
			}
		}
        if(this.state.scteTabSelected){
            return (data && data.dai || []);
        } else{
            return id3;
        }
    }

    spliceTypeRenderer(props: any) {
        if (props === 1) {
            return 'OUT';
        } else if (props === 2) {
            return 'IN';
        } else if (props === 3) {
            return 'ID3';
        }
        return '';
    }

    spliceDurRenderer(props: any, buffer: boolean) {
        let value = props;
        if (value === 0) {
            value = '-';
        }

        const inlineStyle = {
            paddingRight: '10px'
        };

        return(
            <div>
                {buffer ? <span style={inlineStyle}> {value} </span> : value}
            </div>
        );
    }
    
    spliceCommandTypeMap(props: any) {
     	let value = props;
     	switch(value){
     		case 5:
     			return 'Splice Insert';
     			break;
     		case 6:
     			return 'Time Signal';
     			break;
     		default:
     			return '';	
     	}
    }
    
    providerAvailIdRenderer(props: any) {
        let value = props;

        if (value === 0) {
            value = '-';
        }

        const inlineStyle = {
            paddingRight: '15px'
        };

        return <span style={inlineStyle}> {value} </span>;
    }

    booleanRenderer(props: any) {
        if (!props) {
            return '0';
        } else if (props) {
            return '1';
        }
        return props;
    }

    clearLog() {
        axios.delete('http://default/api/log/dai', {
        }).then((response: AxiosResponse) => {
            if ((response.data !== undefined) && (response.data.code === 'SUCCESS')) {
                this.setState({ openModal: true, modalText: 'Log Cleared' });
                this.dataRefresh();
            }
        }).catch((error: AxiosRequestConfig) => {
            this.setState({ openModal: true, modalText: 'Operation Failed.' });
        });
    }

    handleModalClose() {
        this.setState({
            openModal: false
        });
    }

    changeTab(data: any) {
        if (data.activeIndex === 1) {
            this.setState({scteTabSelected: false});
        }  else if (data.activeIndex === 0) {
            this.setState({scteTabSelected: true});
        }
    }

    buildParams() {
        let params = '';
        if ((this.state.startDate) && (!this.state.endDate)) {
            params += 'timerange=' + Math.floor(this.state.startDate / 1000) + '%20to%20current' + '&';
        } else
        if ((this.state.endDate) && (!this.state.startDate)) {
            params += 'timerange=before ' + Math.floor(this.state.endDate / 1000) + '&';
        } else
        if ((this.state.startDate) && (this.state.endDate)) {
            params += 'timerange=' + Math.floor(this.state.startDate / 1000) + ' to ' + Math.floor(this.state.endDate / 1000) + '&';
        }
        if (this.state.assetFilter) {
            params += 'assetName=' + this.state.assetFilter + '&';
        }
        if (this.state.streamFilter) {
            params += 'name=' + this.state.streamFilter + '&';
        }
        if (this.state.spliceFilter) {
            params += 'spliceId=' + this.state.spliceFilter + '&';
        }
        if (this.state.spliceTypeFilter) {
            params += 'spliceType=' + this.state.spliceTypeFilter + '&';
        }
        if (this.state.segTypeFilter) {
        	params += 'segType=' + this.state.segTypeFilter + '&';
        }
		if(!this.state.scteTabSelected){
			params += 'mediaType=' + 'HLS' + '&';
		}
        return params;
    }

    exportLog(oauth: OAuthClientStatus) {
        let now = new Date(); let filename = '';
        let url = (oauth.secureHost ? 'https' : 'http') + '://default/api/export?' + this.buildParams();
        let sysName = (oauth.sys.name ? oauth.sys.name : 'surveyor-abr');
        // sysName = encodeURIComponent(sysName);

        filename += 'IQDaiLog-' + sysName + '-';

        filename += (now.getFullYear() + ('0' + (now.getUTCMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2));
        filename += '-';
        filename += (('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()).slice(-2) + ('0' + now.getSeconds()).slice(-2));
        filename += '.tsv';

        const params = new RequestParameters({
            dataType: 'DaiLog',
            exportFormat: 'tsv',
            filename: filename
        }).queryString();

        if (params.length > 0)
            url += params;

        axios.post(url)
            .then(function (response: AxiosResponse) {
                let stringObject = response.data;
                fileDownload(stringObject, filename);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('Export DAI Log error: ', error);
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/logs/daiLog.tsx